// extracted by mini-css-extract-plugin
export default {"buttonSubmit":"UserPage_buttonSubmit__23QMd","tipBox":"UserPage_tipBox__2BH-L","emailContainer":"UserPage_emailContainer__zLmHG"};